export default __webpack_public_path__ + "static/media/Medium-New.df88f254.png";